import { useState, useEffect } from 'react'

const useLocalStorageToTrackOptin = () => {
  const stateEmailOptIn =
    typeof window !== 'undefined' &&
    JSON.parse(localStorage.getItem('hideEmailOptIn'))

  const [hideEmailOptIn, setHideEmailOptIn] = useState(
    !!stateEmailOptIn?.isHidden
  )

  const onSuccess = () => {
    setHideEmailOptIn(true)
  }

  useEffect(() => {
    localStorage.setItem(
      'hideEmailOptIn',
      JSON.stringify({ isHidden: hideEmailOptIn })
    )
  }, [hideEmailOptIn])

  return { onSuccess }
}
export default useLocalStorageToTrackOptin
